import type { DeprecatedButtonTokens } from '../types';

export const deprecatedButton: DeprecatedButtonTokens = {
  colors: {
    darkButtonTextColor: '#680',
    lightButtonBgColor: 'brandPrimary.0',
  },
};
